import React from 'react';

function Lokalvard() {
  return (
    <>
      <section
        className="relative h-[50vh] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: "url('/images/cleaning/provalt-lokalvard.jpg')", // se till att bilden finns i public/images/cleaning/
        }}
      >
        {/* Mörk överläggning */}
        <div className="absolute inset-0 bg-black bg-opacity-50 z-0" />

        {/* Textinnehåll */}
        <div className="relative z-10 text-center p-6 bg-black bg-opacity-30">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Lokalvård</h1>
          <p className="text-xl md:text-2xl font-semibold">
            Skapa en ren och hälsosam arbetsmiljö med Provalt Service AB
          </p>
        </div>
      </section>
      <section className="py-16 px-6 md:px-12 bg-white text-gray-800">
  <div className="max-w-6xl mx-auto">
    <h2 className="text-3xl md:text-4xl font-bold mb-6">Vad är Lokalvård?</h2>
    <p className="mb-6 text-lg">
      En ren arbetsplats skapar en hälsosam och produktiv miljö för både anställda och kunder. 
      På Provalt Service AB erbjuder vi skräddarsydda lokalvårdstjänster som anpassas efter dina behov 
      och verksamhetens specifika krav. Låt oss ta hand om städningen så att du kan fokusera på din verksamhet.
    </p>
    <p className="mb-10 text-lg">
      Lokalvård innebär den professionella rengöringen av kontor, företagslokaler och andra kommersiella utrymmen. 
      För oss på Provalt Service AB handlar det inte bara om att hålla lokalerna rena, utan att skapa en trivsam 
      och hälsosam arbetsmiljö för dina anställda, kunder och besökare. Vi erbjuder skräddarsydda lokalvårdstjänster 
      som hjälper ditt företag att ge ett bra intryck samtidigt som det bidrar till en bättre arbetsmiljö.
    </p>

    <h3 className="text-2xl md:text-3xl font-semibold mb-4">Våra Tjänster inom Lokalvård:</h3>
    <ul className="list-disc list-inside space-y-3 text-lg">
      <li><strong>Daglig och veckovis städning:</strong> Vi anpassar städningen efter ditt företags behov och scheman, oavsett om det är daglig, veckovis eller vid specifika tillfällen.</li>
      <li><strong>Fönsterputsning:</strong> Vi erbjuder fönsterputsning för att ge ditt kontor ett fräscht och professionellt intryck.</li>
      <li><strong>Golvvård:</strong> Städning av golv, inklusive dammsugning, moppa, polera och underhåll av olika golvtyper.</li>
      <li><strong>Toalett- och kökshygien:</strong> Vi säkerställer att dina toaletter och kök är rena och hygieniska för att skapa en trivsam arbetsmiljö.</li>
      <li><strong>Avfallshantering:</strong> Regelbundet tömmande av papperskorgar och annan avfallshantering.</li>
      <li><strong>Desinfektion av ytor:</strong> För att säkerställa en hygienisk arbetsplats, erbjuder vi desinfektion av högtrafikerade ytor som dörrhandtag, skrivbord och tangentbord.</li>
    </ul>
  </div>
</section>
<section className="py-16 px-6 md:px-12 bg-gray-50 text-gray-800">
  <div className="max-w-6xl mx-auto space-y-12">
    <div>
      <h2 className="text-3xl md:text-4xl font-bold mb-4">Fördelarna med Lokalvård</h2>
      <p className="text-lg mb-6">
        En ren och väl underhållen arbetsplats är avgörande för både produktivitet och hälsa.
        Här är några fördelar med att välja Provalt Service AB för din lokalvård:
      </p>
      <ul className="list-disc list-inside space-y-3 text-lg">
        <li><strong>Hälsosammare arbetsmiljö:</strong> En ren miljö minskar risken för sjukdomar och allergier, vilket leder till färre sjukskrivningar och en mer produktiv arbetsstyrka.</li>
        <li><strong>Professionellt intryck:</strong> En välskött och städad arbetsplats ger ett positivt intryck på både kunder och samarbetspartners.</li>
        <li><strong>Längre livslängd på utrustning och inredning:</strong> Regelbundet underhåll av golv, möbler och utrustning förhindrar slitage och bevarar dina investeringar.</li>
      </ul>
    </div>

    <div>
      <h3 className="text-2xl md:text-3xl font-semibold mb-4">Vårt Engagemang för Miljön</h3>
      <p className="text-lg">
        Vi på Provalt Service AB strävar efter att erbjuda miljövänliga städtjänster. Därför använder vi ekologiska 
        och miljövänliga rengöringsmedel som både är effektiva och snälla mot miljön. Vårt mål är att skapa en ren 
        och hälsosam arbetsmiljö för dig och din personal, samtidigt som vi tar ansvar för vår planet.
      </p>
    </div>

    <div>
      <h3 className="text-2xl md:text-3xl font-semibold mb-4">Flexibilitet och Anpassning</h3>
      <p className="text-lg">
        Vi förstår att varje företag har unika behov. Därför erbjuder vi flexibla lösningar för lokalvård som kan anpassas 
        efter din verksamhets specifika krav. Oavsett om du behöver daglig städning eller en mer omfattande service vid 
        specifika tillfällen, kan vi skapa ett skräddarsytt städschema som passar ditt företags behov.
      </p>
    </div>
  </div>
</section>
<section className="py-16 bg-white text-gray-800">
  <div className="max-w-6xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-10 items-start">
    {/* Textdel */}
    <div>
      <h2 className="text-3xl md:text-4xl font-bold mb-4">Kontakta oss</h2>
      <p className="mb-6 text-lg">
        Tveka inte att kontakta oss för en personlig offert – Vi finns här för dig!
      </p>
      <h3 className="text-2xl font-semibold mb-2">Varför välja oss?</h3>
      <ul className="list-disc list-inside text-lg space-y-3">
        <li><strong>Erfarenhet och kompetens:</strong> Med många års erfarenhet inom städbranschen är vi experter på att leverera högkvalitativa lokalvårdstjänster.</li>
        <li><strong>Professionellt team:</strong> Vårt team är utbildat och använder den senaste tekniken och bästa metoderna för att säkerställa att varje uppdrag utförs noggrant och effektivt.</li>
        <li><strong>Kundnöjdhet:</strong> Vi strävar alltid efter att överträffa våra kunders förväntningar och leverera service av högsta kvalitet.</li>
      </ul>
    </div>

    {/* Formulärdel */}
    <form className="bg-gray-50 shadow-md rounded-lg p-6 space-y-4">
      <div>
        <label className="block text-sm font-medium mb-1">Namn</label>
        <input type="text" className="w-full border rounded p-2" required />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">E-post</label>
        <input type="email" className="w-full border rounded p-2" required />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Företagsnamn</label>
        <input type="text" className="w-full border rounded p-2" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Meddelande</label>
        <textarea
          placeholder="Adress, antal kvm, särskilda önskemål"
          className="w-full border rounded p-2 h-28 resize-none"
          required
        />
      </div>
      <button
        type="submit"
        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded w-full font-semibold"
      >
        Skicka
      </button>
    </form>
  </div>
</section>

    </>
  );
}

export default Lokalvard;
